import { ORDER_OF_CATEGORIES } from 'utils/categoriesOrder';
import { EsrsReportCategory, SideMenuStructure } from '../../Report.types';
import { Paragraph, TextRun } from 'docx';
import { tableOfContents } from '../CustomTables/table-of-content';
import { TextStyle } from '../reportThemes';
import { createStandards } from './standards';

export const createCategories = (
  categories: EsrsReportCategory[],
  companyCurrency: string,
  year: number,
  structure: SideMenuStructure
) => {
  const visibleCategories = categories
    .filter(
      (category) =>
        category.reference === 'general' ||
        category.standards.some((standard) =>
          standard.disclosureRequirements.some((dr) => !dr.isHidden)
        )
    )
    .sort((a, b) => ORDER_OF_CATEGORIES[a.title] - ORDER_OF_CATEGORIES[b.title]);

  const displayedCategories = visibleCategories.flatMap((category, index) => {
    let tableOfContent: any[] = [];
    if (visibleCategories?.[index - 1]?.reference === 'general') {
      tableOfContent = tableOfContent = [
        new Paragraph({
          children: [],
          pageBreakBefore: true,
        }),
        ...tableOfContents(structure),
        new Paragraph({
          children: [],
          pageBreakBefore: true,
        }),
      ];
    }

    return [
      ...tableOfContent,
      new Paragraph({
        text: `${category.title === 'Environment' ? 'Environmental' : category.title} information`,
        style: TextStyle.h3,
        spacing: {
          after: 300,
        },
        numbering: {
          level: 0,
          reference: 'number-system',
        },
      }),
      category.title === 'Environment'
        ? new Paragraph({
            style: TextStyle.h1,
            shading: {
              type: 'solid',
              color: 'DCF6ED',
            },
            children: [
              new TextRun({
                text: 'Disclosures pursuant to Article 8 of Regulation (EU) 2020/852 (Taxonomy Regulation)',
              }),
            ],
            spacing: {
              after: 800,
            },
          })
        : {},
      createStandards(category.standards, companyCurrency, year),
    ];
  });
  return displayedCategories.flat();
};
